/* ============================================================
   ooo-xsellnew — section-scoped interactions.
   Ported from the source homepage script.js, MINUS the bits the
   foundation already owns:
     - scroll reveal  -> ooo-motion.js (.ooo-reveal / [data-ooo-reveal-group])
     - mobile menu     -> ooo-header.js
     - add-to-cart     -> ooo-cart.js (intercepts form[action*="/cart/add"])
   This file handles only:
     1) Lineup card Subscribe / One-time purchase toggle (sets the
        hidden [name=id] so the global cart interceptor adds the right
        variant; blank id -> ooo-cart.js no-ops gracefully).
     2) Testimonial carousel arrows + dots.
   Idempotent: guards against double-binding on theme-editor re-renders.
   ============================================================ */
(function () {
  'use strict';

  /* 1 ── Lineup purchase-type toggle ────────────────────────── */
  function bindLineup(root) {
    (root || document).querySelectorAll('[data-ooo-lcard]').forEach(function (form) {
      if (form.dataset.oooBound) return;
      form.dataset.oooBound = '1';

      var opts = form.querySelectorAll('[data-ooo-opt]');
      var spInput = form.querySelector('[data-ooo-sp]');
      var planId = spInput ? String(spInput.value || '').trim() : '';

      function activate(opt) {
        opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('is-active');
        opt.setAttribute('aria-pressed', 'true');
        /* subscribe -> pass the SKIO selling plan; one-time (or no plan) -> drop it */
        if (spInput) spInput.disabled = (opt.getAttribute('data-mode') !== 'sub') || !planId;
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { activate(opt); });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(opt); }
        });
        opt.setAttribute('tabindex', '0');
        opt.setAttribute('role', 'button');
      });

      /* set initial selling_plan state from the pre-active option */
      var initActive = form.querySelector('[data-ooo-opt].is-active') || opts[0];
      if (initActive) activate(initActive);

      /* supply dropdown -> quantity + prices + cadence */
      var supplySel = form.querySelector('[data-ooo-supply]');
      if (supplySel) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        var supLabel = form.querySelector('[data-ooo-supply-label]');
        var subPriceEl = form.querySelector('[data-ooo-sub-price]');
        var oncePriceEl = form.querySelector('[data-ooo-once-price]');
        var subNoteEl = form.querySelector('[data-ooo-sub-note]');
        var money = function (c) { return '$' + ((parseInt(c, 10) || 0) / 100).toFixed(2); };
        var applySupply = function () {
          var opt = supplySel.options[supplySel.selectedIndex];
          if (!opt) return;
          if (qtyInput) qtyInput.value = supplySel.value;
          if (supLabel) supLabel.textContent = opt.textContent;
          if (subPriceEl) subPriceEl.textContent = money(opt.getAttribute('data-sub'));
          if (oncePriceEl) oncePriceEl.textContent = money(opt.getAttribute('data-once'));
          if (subNoteEl) subNoteEl.textContent = 'Every ' + opt.getAttribute('data-days') + ' days';
        };
        supplySel.addEventListener('change', applySupply);
        applySupply();
      }
    });
  }

  /* 2 ── Testimonial carousel ───────────────────────────────── */
  function bindCarousel(root) {
    (root || document).querySelectorAll('[data-ooo-carousel-rail]').forEach(function (rail) {
      if (rail.dataset.oooBound) return;
      rail.dataset.oooBound = '1';

      var section = rail.closest('.ooo-says') || document;
      var prev = section.querySelector('[data-ooo-carousel-prev]');
      var next = section.querySelector('[data-ooo-carousel-next]');
      var dots = section.querySelectorAll('[data-ooo-carousel-dots] i');

      function step() {
        var card = rail.querySelector('.ooo-tcard');
        if (!card) return 300;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '22') || 22;
        return card.getBoundingClientRect().width + gap;
      }

      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

      rail.addEventListener('scroll', function () {
        var i = Math.round(rail.scrollLeft / step());
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === Math.min(i, dots.length - 1));
        });
      }, { passive: true });
    });
  }

  function init(root) { bindLineup(root); bindCarousel(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme-editor live re-render hooks */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
